// src/stores/congTrinhStore.js
import chatCongTrinhService from "@/services/chatCongTrinhService";
import congTrinhHangMucService from "@/services/congTrinhHangMucService";
import congTrinhService from "@/services/congTrinhService";
import deXuatVatTuCongTrinhService from "@/services/deXuatVatTuCongTrinhService";
import keHoachNhanSuCongTrinhService from "@/services/keHoachNhanSuCongTrinhService";
import nhanSuCongTrinhService from "@/services/nhanSuCongTrinhService";
import TaiLieuCongTrinhService from "@/services/TaiLieuCongTrinhService";
import vatTuCongTrinhService from "@/services/vatTuCongTrinhService";
import { defineStore } from "pinia";


export const useCongTrinhStore = defineStore("congTrinh", {
  state: () => ({
    danhSachCongTrinh: [],
    userOptions: [], 
    thoivuOptions: [],
    checklist: [],
    congTrinhDangChon: null,
    isLoading: false,
    usersOptions: [], // Danh sách user để chọn quản lý
    error: null,
    unreadCount: 0,
  }),

  actions: {
    // 1. Lấy danh sách công trình
    async fetchDanhSachCongTrinh() {
      this.isLoading = true;
      this.error = null;
      try {
        const response = await congTrinhService.getAll();
        // Backend trả về ApiResponse { code: 200, data: [...] } hoặc mảng trực tiếp
        this.danhSachCongTrinh = response.data.data || response; 
      } catch (err) {
        console.error("Lỗi tải danh sách:", err);
        this.error = "Không thể tải danh sách.";
      } finally {
        this.isLoading = false;
      }
    },

    // 2. Lấy danh sách User (để nạp vào dropdown chọn quản lý)
    async fetchUsersOptions() {
      try {
        const response = await congTrinhService.getUserOptions();
        this.usersOptions = response.data || response;
      } catch (err) {
        console.error("Không tải được danh sách user:", err);
      }
    },

    // 3. Tạo công trình mới
    async themCongTrinh(payload) {
      this.isLoading = true;
      try {
        const response = await congTrinhService.create(payload);
        const newProject = response.data.data || response;
        
        // Thêm vào đầu danh sách hiển thị
        this.danhSachCongTrinh.unshift(newProject);
        return newProject;
      } catch (err) {
        console.error("Lỗi tạo dự án:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },

    // 4. Chọn công trình (Chi tiết)
    async chonCongTrinh(id) {
        if (!id) return;
        this.congTrinhDangChon = null;
        this.isLoading = true;
        try {
            const response = await congTrinhService.getDetail(id);
            this.congTrinhDangChon = response.data.data || response;
        } catch(err) {
            console.error("Lỗi tải chi tiết:", err);
            this.congTrinhDangChon = null;
        } finally {
            this.isLoading = false;
        }
    },

    async capNhatCongTrinh(id, payload) {
      this.isLoading = true;
      try {
        const response = await congTrinhService.update(id, payload);
        
        // Backend trả về: { code: 200, data: { ...CongTrinhDetail... } }
        // Cần cập nhật lại state để giao diện tự động refresh thông tin mới
        const updatedData = response.data?.data || response;
        this.congTrinhDangChon = updatedData;
        
        return updatedData;
      } catch (err) {
        console.error("Lỗi cập nhật:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },

    async fetchDsHangMuc(congTrinhId) {

        this.isLoading = true;
        try {
            const res = await congTrinhHangMucService.getAll(congTrinhId);
            const listData = res.data?.data || res;
            
            if (this.congTrinhDangChon) {
                this.congTrinhDangChon.hangMucThiCong = listData;
            }
        } catch (err) {
            console.error("Lỗi tải hạng mục:", err);
        } finally {
            this.isLoading = false;
        }
    },

    async themHangMuc(congTrinhId, payload) {
        this.isLoading = true;
        try {
            const res = await congTrinhHangMucService.create(congTrinhId, payload);
            const newItem = res.data?.data || res;
            
            // Cập nhật State ngay lập tức để Gantt vẽ lại
            if (this.congTrinhDangChon) {
                if (!this.congTrinhDangChon.hangMucThiCong) this.congTrinhDangChon.hangMucThiCong = [];
                this.congTrinhDangChon.hangMucThiCong.push(newItem);
            }
        } catch (err) {
            console.error("Lỗi thêm hạng mục:", err);
            throw err;
        } finally {
            this.isLoading = false;
        }
    },

    async capNhatHangMuc(hangMucId, payload) {
        this.isLoading = true;
        try {
            const res = await congTrinhHangMucService.update(hangMucId, payload);
            const updatedItem = res.data?.data || res;

            // Tìm và thay thế trong State
            if (this.congTrinhDangChon?.hangMucThiCong) {
                const idx = this.congTrinhDangChon.hangMucThiCong.findIndex(x => x.id === hangMucId);
                if (idx !== -1) {
                    this.congTrinhDangChon.hangMucThiCong[idx] = updatedItem;
                }
            }
        } catch (err) {
            console.error("Lỗi sửa hạng mục:", err);
            throw err;
        } finally {
            this.isLoading = false;
        }
    },

    async xoaHangMuc(hangMucId) {
        this.isLoading = true;
        try {
            await congTrinhHangMucService.delete(hangMucId);
            
            // Xóa khỏi State
            if (this.congTrinhDangChon?.hangMucThiCong) {
                this.congTrinhDangChon.hangMucThiCong = this.congTrinhDangChon.hangMucThiCong.filter(x => x.id !== hangMucId);
            }
        } catch (err) {
            console.error("Lỗi xóa hạng mục:", err);
            throw err;
        } finally {
            this.isLoading = false;
        }
    },

    async capNhatTienDoHangMuc(hangMucId, progress) {
        try {
            // Gọi API Patch đã viết ở HangMucThiCongController
            await congTrinhHangMucService.capNhatTienDo (hangMucId, progress);
            
            // Cập nhật State Local ngay lập tức để UI mượt
            if(this.congTrinhDangChon?.hangMucThiCong) {
                const hm = this.congTrinhDangChon.hangMucThiCong.find(x => x.id === hangMucId);
                if(hm) hm.progress = progress;
            }
        } catch (e) {
            console.error("Lỗi update tiến độ:", e);
        }
    },

    // ===== VẬT TƯ ƯỚC LƯỢNG =====

    async fetchThongKeVatTu(id) {
      try {
        const res = await vatTuCongTrinhService.getThongKeVatTu(id);
        // Kiểm tra cấu trúc trả về của API (thường là res.data.data hoặc res.data)
        const data = res.data.data || res.data || [];
        
        if (this.congTrinhDangChon) {
          this.congTrinhDangChon.thongKeVatTu = data;
        }
      } catch (error) {
        console.error("Lỗi tải thống kê vật tư:", error);
      }
    },

    async fetchVatTuUocLuong(congTrinhId) {
      if (!congTrinhId) return;
      this.isLoading = true;
      try {
        const res = await vatTuCongTrinhService.getByCongTrinh(congTrinhId);
        // Cập nhật vào state của công trình đang chọn
        if (this.congTrinhDangChon) {
          this.congTrinhDangChon.vatTuUocLuong = res.data.data || res.data;
        }
      } catch (err) {
        console.error("Lỗi tải vật tư:", err);
      } finally {
        this.isLoading = false;
      }
    },

    // 2. Thêm 1 vật tư
    async themVatTuUocLuong(congTrinhId, payload) {
      this.isLoading = true;
      try {
        const res = await vatTuCongTrinhService.create(congTrinhId, payload);
        const newItem = res.data.data || res.data;
        
        // Push vào state để hiển thị ngay
        if (this.congTrinhDangChon) {
           if (!this.congTrinhDangChon.vatTuUocLuong) this.congTrinhDangChon.vatTuUocLuong = [];
           this.congTrinhDangChon.vatTuUocLuong.unshift(newItem); // Thêm lên đầu
        }
        return newItem;
      } catch (err) {
        console.error("Lỗi thêm vật tư:", err);
        throw err; // Ném lỗi để component bắt hiển thị alert
      } finally {
        this.isLoading = false;
      }
    },

    // 3. Cập nhật vật tư
    async capNhatVatTuUocLuong(vatTuId, payload) {
      this.isLoading = true;
      try {
        const res = await vatTuCongTrinhService.update(vatTuId, payload);
        const updatedItem = res.data.data || res.data;

        // Cập nhật lại item trong mảng state
        if (this.congTrinhDangChon?.vatTuUocLuong) {
          const idx = this.congTrinhDangChon.vatTuUocLuong.findIndex(x => x.id === vatTuId);
          if (idx !== -1) {
            this.congTrinhDangChon.vatTuUocLuong[idx] = updatedItem;
          }
        }
      } catch (err) {
        console.error("Lỗi sửa vật tư:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },

    // 4. Xóa vật tư
    async xoaVatTuUocLuong(vatTuId) {
      this.isLoading = true;
      try {
        await vatTuCongTrinhService.delete(vatTuId);
        // Filter xóa khỏi state
        if (this.congTrinhDangChon?.vatTuUocLuong) {
          this.congTrinhDangChon.vatTuUocLuong = this.congTrinhDangChon.vatTuUocLuong.filter(x => x.id !== vatTuId);
        }
      } catch (err) {
        console.error("Lỗi xóa vật tư:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },

    // 5. Import Excel (Batch)
    async importVatTuTuExcel(congTrinhId, listRows) {
      this.isLoading = true;
      try {
        const res = await vatTuCongTrinhService.createBatch(congTrinhId, listRows);
        const listNewItems = res.data.data || res.data;
        
        // Gộp vào danh sách hiện tại hoặc load lại
        if (this.congTrinhDangChon) {
           if (!this.congTrinhDangChon.vatTuUocLuong) this.congTrinhDangChon.vatTuUocLuong = [];
           // Cách 1: Load lại toàn bộ (an toàn nhất)
           // await this.fetchVatTuUocLuong(congTrinhId);
           
           // Cách 2: Push vào (nhanh hơn)
           this.congTrinhDangChon.vatTuUocLuong.push(...listNewItems);
        }
      } catch (err) {
        console.error("Lỗi import excel:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },

    // ===== ĐỀ XUẤT VẬT TƯ (API) =====
    
    // 1. Tải danh sách đề xuất
    async fetchDeXuatVatTu(congTrinhId) {
      if (!congTrinhId) return;
      try {
        const res = await deXuatVatTuCongTrinhService.getByCongTrinh(congTrinhId);
        if (this.congTrinhDangChon) {
          this.congTrinhDangChon.deXuatVatTu = res.data.data || res.data;
        }
      } catch (err) {
        console.error("Lỗi tải đề xuất:", err);
      }
    },

    // 2. Tạo đề xuất mới
    async taoDeXuatVatTu(congTrinhId, payload) {
      try {
        const res = await deXuatVatTuCongTrinhService.create(congTrinhId, payload);
        const newItem = res.data.data || res.data;
        
        // Push vào đầu danh sách để hiển thị ngay
        if (this.congTrinhDangChon) {
           if (!this.congTrinhDangChon.deXuatVatTu) this.congTrinhDangChon.deXuatVatTu = [];
           this.congTrinhDangChon.deXuatVatTu.unshift(newItem);
        }
        return newItem;
      } catch (err) {
        console.error("Lỗi tạo đề xuất:", err);
        throw err;
      }
    },

    // 3. Duyệt / Từ chối
    async duyetDeXuatVatTu(deXuatId, isApproved, reason = null) {
      try {
        await deXuatVatTuCongTrinhService.approve(deXuatId, { approved: isApproved, reason });
        
        // Cập nhật state local
        if (this.congTrinhDangChon?.deXuatVatTu) {
          const dx = this.congTrinhDangChon.deXuatVatTu.find(x => x.id === deXuatId);
          if (dx) {
            dx.trangThai = isApproved ? "DA_DUYET" : "TU_CHOI";
            dx.lyDoTuChoi = reason;
          }
        }
      } catch (err) {
        console.error("Lỗi duyệt đề xuất:", err);
        throw err;
      }
    },

    // 4. Xác nhận nhận hàng
    async xacNhanNhanVatTu(deXuatId, images = []) {
      try {
        await deXuatVatTuCongTrinhService.confirm(deXuatId, { images });
        
        // Cập nhật state local
        if (this.congTrinhDangChon?.deXuatVatTu) {
          const dx = this.congTrinhDangChon.deXuatVatTu.find(x => x.id === deXuatId);
          if (dx) {
            dx.trangThai = "DA_HOAN_THANH";
            dx.anhXacNhan = images;
          }
        }
        
        // Reload lại inventory vì số lượng "Đã cấp" sẽ thay đổi
        if (this.congTrinhDangChon?.id) {
           // Giả sử logic tính inventory của bạn dựa trên danh sách đề xuất đã hoàn thành
           // thì việc cập nhật state ở trên là đủ để computed property tự tính lại.
           // Nếu cần chắc chắn, gọi lại fetchVatTuUocLuong()
        }
      } catch (err) {
        console.error("Lỗi xác nhận:", err);
        throw err;
      }
    },

    // 5. Cập nhật đề xuất
    async capNhatDeXuatVatTu(deXuatId, payload) {
      try {
        const res = await deXuatVatTuCongTrinhService.update(deXuatId, payload);
        const updatedItem = res.data.data || res.data;

        // Cập nhật lại trong danh sách local
        if (this.congTrinhDangChon?.deXuatVatTu) {
          const idx = this.congTrinhDangChon.deXuatVatTu.findIndex(x => x.id === deXuatId);
          if (idx !== -1) {
            // Giữ nguyên vị trí, thay thế data mới
            this.congTrinhDangChon.deXuatVatTu.splice(idx, 1, updatedItem);
          }
        }
      } catch (err) {
        console.error("Lỗi cập nhật đề xuất:", err);
        throw err;
      }
    },

    // ===== NHÂN SỰ =====

    // 1. Tải danh sách và chia về 2 mảng UI
    async fetchNhanSu(congTrinhId) {
      if (!congTrinhId) return;
      this.isLoading = true;
      try {
        const res = await nhanSuCongTrinhService.getByCongTrinh(congTrinhId);
        const list = res.data.data || res.data;

        if (this.congTrinhDangChon) {
          // Logic chia UI:
          // - Nhân sự chính: Là CHINH_THUC và có vai trò quản lý (TRUONG_NHOM, GIAM_SAT)
          this.congTrinhDangChon.nhanSuChinh = list.filter(
            x => x.loaiNhanSu === 'CHINH_THUC' && ['TRUONG_NHOM', 'GIAM_SAT'].includes(x.vaiTro)
          );

          // - Nhân sự thi công: Là THOI_VU hoặc CHINH_THUC nhưng vai trò là THO/KHAC
          this.congTrinhDangChon.nhanSuThiCong = list.filter(
            x => x.loaiNhanSu === 'THOI_VU' || (x.loaiNhanSu === 'CHINH_THUC' && !['TRUONG_NHOM', 'GIAM_SAT'].includes(x.vaiTro))
          );
        }
      } catch (err) {
        console.error("Lỗi tải nhân sự:", err);
      } finally {
        this.isLoading = false;
      }
    },

    // 2. Thêm nhân sự
    async themNhanSu(congTrinhId, payload) {
      try {
        await nhanSuCongTrinhService.add(congTrinhId, payload);
        // Reload lại danh sách để auto chia nhóm
        await this.fetchNhanSu(congTrinhId);
      } catch (err) {
        console.error("Lỗi thêm nhân sự:", err);
        throw err;
      }
    },

    // 3. Xóa nhân sự
    async xoaNhanSu(id) {
      try {
        await nhanSuCongTrinhService.delete(id);
        // Reload lại danh sách
        if (this.congTrinhDangChon) {
           await this.fetchNhanSu(this.congTrinhDangChon.id);
        }
      } catch (err) {
        console.error("Lỗi xóa nhân sự:", err);
        throw err;
      }
    },

    // 4. Load Options cho Dropdown
    async fetchOptionsNhanSu() {
      try {
        // Gọi song song
        const [resUsers, resThoivu] = await Promise.all([
            nhanSuCongTrinhService.getUserOptions(),
            nhanSuCongTrinhService.getThoiVuOptions()
        ]);
        
        this.userOptions = resUsers.data || [];
        this.thoivuOptions = (resThoivu.data?.data?.content || resThoivu.data?.data) || [];
      } catch (e) {
        console.error("Lỗi load options:", e);
      }
    },

    // ===== KẾ HOẠCH & NHÂN SỰ =====
    
    // 1. Tải dữ liệu Tab (Mặc định lấy ngày mai nếu không truyền date)
    async fetchKeHoachNhanSu(congTrinhId, dateStr = null) {
      if (!congTrinhId) return;
      // Nếu không có dateStr, tự động lấy ngày mai (YYYY-MM-DD)
      if (!dateStr) {
         const tomorrow = new Date();
         tomorrow.setDate(tomorrow.getDate() + 1);
         dateStr = tomorrow.toISOString().split('T')[0];
      }

      try {
        const res = await keHoachNhanSuCongTrinhService.getData(congTrinhId, dateStr);
        const data = res.data.data || res.data;

        if (this.congTrinhDangChon) {
          // Cập nhật State từ API
          this.congTrinhDangChon.keHoachNgayMai = data.keHoachNgayMai || [];
          this.congTrinhDangChon.keHoachNhanSuNgayMai = data.nhanSuNgayMai || [];
          this.congTrinhDangChon.lichCongNgay = data.lichSuCong || [];
        }
      } catch (err) {
        console.error("Lỗi tải kế hoạch:", err);
      }
    },

    // 2. Thêm đầu việc
    async themKeHoachNgayMai(payload) {
        if (!this.congTrinhDangChon) return;
        try {
            const res = await keHoachNhanSuCongTrinhService.createPlan(this.congTrinhDangChon.id, payload);
            const newItem = res.data.data || res.data;
            this.congTrinhDangChon.keHoachNgayMai.unshift(newItem);
        } catch (e) {
            throw e;
        }
    },

    // 3. Sửa đầu việc
    async capNhatKeHoachNgayMai(planId, payload) {
        if (!this.congTrinhDangChon) return;
        try {
            const res = await keHoachNhanSuCongTrinhService.updatePlan(planId, payload);
            const updatedItem = res.data.data || res.data;
            
            // Update local
            const idx = this.congTrinhDangChon.keHoachNgayMai.findIndex(x => x.id === planId);
            if(idx !== -1) {
                this.congTrinhDangChon.keHoachNgayMai.splice(idx, 1, updatedItem);
            }
        } catch (e) {
            throw e;
        }
    },

    // 4. Xóa đầu việc
    async xoaKeHoachNgayMai(planId) {
        if (!this.congTrinhDangChon) return;
        try {
            await keHoachNhanSuCongTrinhService.deletePlan(planId);
            this.congTrinhDangChon.keHoachNgayMai = this.congTrinhDangChon.keHoachNgayMai.filter(x => x.id !== planId);
        } catch (e) {
            throw e;
        }
    },

    // 5. Lưu phân công (Checkbox)
    async luuPhanCongNhanSu(dateStr, items) {
        if (!this.congTrinhDangChon) return;
        try {
            await keHoachNhanSuCongTrinhService.savePhanCong(this.congTrinhDangChon.id, {
                ngayLamViec: dateStr,
                items: items
            });
            // Không cần reload lại toàn bộ, vì UI đã phản ánh thay đổi rồi
            // Hoặc nếu muốn chắc chắn thì gọi fetchKeHoachNhanSu lại
        } catch (e) {
            throw e;
        }
    },

    async fetchChiTietNgay(congTrinhId, dateStr) {
       // Tái sử dụng API ke-hoach-nhan-su đã viết ở phần trước
       try {
           const res = await keHoachNhanSuCongTrinhService.getData(congTrinhId, dateStr);
           const data = res.data.data || res.data;
           // Lưu vào state tạm để hiển thị ở Overview (tránh ghi đè state chính nếu không muốn)
           this.overviewData = {
               keHoach: data.keHoachNgayMai || [],
               nhanSu: data.nhanSuNgayMai || [] // Lưu ý: API cũ tên field là 'nhanSuNgayMai'
           };
       } catch (e) {
           console.error(e);
       }
    },

    // Lấy dữ liệu chấm dot cho lịch
    async fetchCalendarEvents(congTrinhId, month, year) {
        try {
            const res = await keHoachNhanSuCongTrinhService.calendarEvents(congTrinhId,month,year)
            this.calendarEvents = res.data.data || res.data;
        } catch (e) {
            console.error(e);
        }
    },

    // 2. LẤY CHECKLIST
    async fetchChecklist(congTrinhId) {
        try {
            const res = await keHoachNhanSuCongTrinhService.fetchChecklist(congTrinhId);
            this.checklist = res.data.data || res.data;
        } catch (e) {
            console.error(e);
        }
    },

    // 3. TOGGLE CHECKLIST (Tick checkbox)
    async toggleChecklist(planId, isDone) {
        try {
            keHoachNhanSuCongTrinhService.toggleChecklist(planId, isDone);
            // Không cần load lại, UI đã v-model rồi
        } catch (e) {
            console.error(e);
            // Nếu lỗi thì revert UI (logic xử lý ở component hoặc load lại list)
            alert("Lỗi kết nối, vui lòng thử lại");
        }
    },

    // ===== TÀI LIỆU CÔNG TRÌNH =====

    // 1. Tải danh sách tài liệu
    async fetchTaiLieu(congTrinhId) {
        if (!congTrinhId) return;
        try {
            const res = await TaiLieuCongTrinhService.getByCongTrinh(congTrinhId);
            if (this.congTrinhDangChon) {
                // Backend trả về: { data: [...] } hoặc trực tiếp mảng tùy config
                const list = res.data.data || res.data || [];
                
                // Map dữ liệu để khớp với UI nếu cần
                this.congTrinhDangChon.taiLieu = list;
            }
        } catch (err) {
            console.error("Lỗi tải tài liệu:", err);
        }
    },
// 1.1 Tải danh sách tài liệu phân loại
    async fetchTaiLieuPhanLoai(congTrinhId) {
        try {
            const res = await TaiLieuCongTrinhService.getByCongTrinh(congTrinhId);
            const list = res.data.data || res.data || [];
            
            if (this.congTrinhDangChon) {
                // Phân loại dữ liệu cho TabTaiLieu.vue dễ dùng
                this.congTrinhDangChon.taiLieuHuongDan = list.filter(x => 
                    x.loai === 'HUONG_DAN_THI_CONG' || x.loai === 'KHAC'
                );
                
                this.congTrinhDangChon.hoSoKiemDinh = list.filter(x => 
                    ['HO_SO_KIEM_DINH', 'HO_SO_CONG_NHAN', 'PHAP_LY'].includes(x.loai)
                );
            }
        } catch (err) {
            console.error(err);
        }
    },

    // 2. Thêm tài liệu
    async themTaiLieu(congTrinhId, payload) {
        try {
            const res = await TaiLieuCongTrinhService.create(congTrinhId, payload);
            // Sau khi thêm, tải lại danh sách
            await this.fetchTaiLieu(congTrinhId);
            return res.data;
        } catch (e) {
            throw e;
        }
    },

    // 3. Cập nhật tài liệu
    async capNhatTaiLieu(id, payload) {
        try {
            const res = await TaiLieuCongTrinhService.update(id, payload);
            // Cập nhật cục bộ để không phải load lại toàn bộ
            if (this.congTrinhDangChon && this.congTrinhDangChon.taiLieu) {
                const idx = this.congTrinhDangChon.taiLieu.findIndex(x => x.id === id);
                if (idx !== -1) {
                    // Merge dữ liệu cũ với mới
                    this.congTrinhDangChon.taiLieu[idx] = { 
                        ...this.congTrinhDangChon.taiLieu[idx], 
                        ...res.data.data 
                    }; 
                }
            }
            return res.data;
        } catch (e) {
            throw e;
        }
    },

    // 4. Xóa tài liệu
    async xoaTaiLieu(id) {
        try {
            await TaiLieuCongTrinhService.delete(id);
            if (this.congTrinhDangChon && this.congTrinhDangChon.taiLieu) {
                this.congTrinhDangChon.taiLieu = 
                    this.congTrinhDangChon.taiLieu.filter(x => x.id !== id);
            }
        } catch (e) {
            throw e;
        }
    },

    // ===== BẮT ĐẦU THI CÔNG =====
    batDauThiCong() {
      if (!this.congTrinhDangChon) return;
      this.congTrinhDangChon.trangThai = "DangThiCong";
    },

    // --- CHAT ACTIONS ---

    async fetchChatHistory(congTrinhId, page = 0, size = 20) {
      try {
        const res = await chatCongTrinhService.getHistory(congTrinhId, { page, size });
        return res.data.data || res.data; // Trả về Page object (content, totalElements...)
      } catch (e) {
        console.error("Lỗi tải lịch sử chat:", e);
        throw e;
      }
    },

    async sendChatMessage(congTrinhId, userId, payload) {
      try {
        // Gọi service gửi tin
        await chatCongTrinhService.sendMessage(congTrinhId, userId, payload);
        // Không cần làm gì thêm vì Socket sẽ nhận tin nhắn về và update UI
      } catch (e) {
        console.error("Lỗi gửi tin:", e);
        throw e;
      }
    },

    async fetchPinnedMessages(congTrinhId) {
      try {
        const res = await chatCongTrinhService.getPinned(congTrinhId);
        return res.data.data || res.data;
      } catch (e) {
        console.error("Lỗi tải tin ghim:", e);
        return [];
      }
    },

    async togglePinMessage(msgId) {
      try {
        await chatCongTrinhService.togglePin(msgId);
      } catch (e) {
        console.error("Lỗi ghim tin:", e);
        throw e;
      }
    },

    async markChatRead(congTrinhId, userId) {
      try {
        await chatCongTrinhService.markRead(congTrinhId, userId);
        this.unreadCount = 0; // Reset badge về 0
      } catch (e) {
        console.error("Lỗi đánh dấu đã đọc:", e);
      }
    },

    async updateUnreadCount(congTrinhId, userId) {
      try {
        const res = await chatCongTrinhService.getUnreadCount(congTrinhId, userId);
        this.unreadCount = res.data.data || res.data;
      } catch (e) {
        console.error("Lỗi đếm tin chưa đọc:", e);
      }
    }
  },
});